export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home'),
    meta: {
      title: 'Save money on tax',
      description: 'Saving money on tax for you and your staff',
    }
  },
  {
    path: '/how-it-works',
    name: 'How it works',
    component: () => import ('../views/HowItWorks'),
    meta: {
      title: 'How it works',
      description: 'How SalarySeed can help you save money, and frequently asked questions',
    }
  },
  {
    path: '/about',
    name: 'Our mission',
    component: () => import ('../views/About'),
    meta: {
      title: 'Our mission',
      description: 'Our mission and more about us',
    }
  },
  {
    path: '/contact',
    name: 'Contact us',
    component: () => import ('../views/Contact'),
    meta: {
      title: 'Contact us',
      description: 'Any more questions? Pop us an email or give us a call',
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import ('../views/Register'),
    meta: {
      title: 'Register with SalarySeed',
      description: 'Register with us and start saving money on tax today',
    }
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: () => import('../views/Privacy'),
    meta: {
      title: 'Privacy policy',
      description: 'SalarySeed\'s privacy policy and terms and conditions',
    }
  }
];
